import React, { useEffect, useState } from "react";
import { Navigate, Routes, Route, useLocation } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import CatalogWorkspace from "./pages/CatalogWorkspace";
import AdminPage from "./pages/AdminPage";
import LoginPage from "./pages/LoginPage";
import { getSession, subscribeToAuth } from "./api/auth";

function AdminRoute() {
   const location = useLocation();
   const params = new URLSearchParams(location.search);
   if (params.get("tab") === "catalogPrototype") {
      params.set("tab", "catalog");
      return <Navigate to={`/?${params}`} replace />;
   }
   return <AdminPage />;
}

export default function App() {
   const [session, setSession] = useState(getSession());

   useEffect(() => subscribeToAuth(() => setSession(getSession())), []);

   return (
      <Routes>
         <Route path="/admin" element={<AdminRoute />} />
         <Route path="/sym/admin" element={<AdminRoute />} />
         <Route path="/users" element={<Navigate to="/sym/admin?tab=users" replace />} />
         <Route path="/sym/users" element={<Navigate to="/sym/admin?tab=users" replace />} />
         <Route path="/bm25" element={<Navigate to="/sym/admin?tab=superset" replace />} />
         <Route path="/sym/bm25" element={<Navigate to="/sym/admin?tab=superset" replace />} />
         <Route path="/documents/archive" element={<Navigate to="/sym/admin?tab=documents" replace />} />
         <Route path="/sym/documents/archive" element={<Navigate to="/sym/admin?tab=documents" replace />} />

         <Route path="/legacy" element={session ? <MainLayout session={session} /> : <LoginPage onLogin={setSession} />} />
         {/* Основное рабочее пространство */}
         <Route
            path="*"
            element={session ? <CatalogWorkspace /> : <LoginPage onLogin={setSession} />}
         />
      </Routes>
   );
}
